import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root', // This ensures it's a singleton service
})
export class AppPayService {
  private mobilePayData: any | null = null; // Private data
  private storageKey = 'mobilePayData';
  // Setter method to store data
  setMobilePayData(data: any): void {
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  // Getter method to retrieve data
  getMobilePayData(): any | null {
    const storedData = localStorage.getItem(this.storageKey);
    return storedData ? JSON.parse(storedData) : null;
  }

  // Optional: Clear the data (e.g., after it's consumed)
  clearMobilePayData(): void {
    localStorage.removeItem(this.storageKey);
  }
}
